import { Parallax, ParallaxLayer } from '@react-spring/parallax';
import React from "react";
import Unity, { UnityContext } from "react-unity-webgl";

import './play.css'
import symbol from '../../assets/img/symbolPic.png'

const unityContext = new UnityContext({
  loaderUrl: "mmmbuild2/Build/Midnight Metal Madness 2.loader.js",
  dataUrl: "mmmbuild2/Build/Midnight Metal Madness 2.data",
  frameworkUrl: "mmmbuild2/Build/Midnight Metal Madness 2.framework.js",
  codeUrl: "mmmbuild2/Build/Midnight Metal Madness 2.wasm",
});

function Play() {
  return (
    <div className='game'>
      <Unity unityContext={unityContext}/>
    </div>
  );
}

export default Play;
